var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center text-center h-32 text-gray-500"},[_c('i',{class:['fas', _vm.icon, 'text-2xl mb-2']}),_c('span',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }